import { Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import BankedPublishSkeleton from "@/Components/common/BankedPublishSkeleton";
import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { TimePickerClock } from "@/Components/Icons/TimePickerClock";
import {
  toggleBankPublishContractDurationModal,
  updateBankContractPublishHours,
  updateClientPublishBankContractDuration,
} from "@/reducers/clientcommon";

import { SelectDownIcon } from "../../../Icons/SelectDownIcon";

const BankedPushlishContractDurationModal = () => {
  const {
    bankContractPublishHours,
    setbankContractPublishLoading,
    bankPublishContractDurationModal,
    oldBankContractPublishHours,
  } = useSelector((state) => state.clientCommon);
  const [durationType, setDurationType] = useState("days"); // New state for type (Days/Hours)
  const [durationValue, setDurationValue] = useState(1);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const computedDays = Math.floor(bankContractPublishHours / 24);
    const computedHours = bankContractPublishHours % 24 || 1;
    setDurationType(computedDays > 0 ? "days" : "hours");
    setDurationValue(computedDays > 0 ? computedDays : computedHours);
  }, [bankContractPublishHours]);

  const resetToOldValues = () => {
    const oldDays = Math.floor(oldBankContractPublishHours / 24);
    const oldHours = oldBankContractPublishHours % 24 || 0;
    setDurationType(oldDays > 0 ? "days" : "hours");
    setDurationValue(oldDays > 0 ? oldDays : oldHours);
    setError("");
  };

  const handleDurationChange = (value) => {
    setDurationValue(value);
    setError("");
  };

  const handleSave = () => {
    const totalHours =
      durationType === "days"
        ? durationValue * 24
        : parseInt(durationValue, 10) || 0;

    if (
      durationType === "hours" &&
      (durationValue < 1 || durationValue > 999)
    ) {
      setError("Please enter a valid duration between 1 and 999 hours.");
      return;
    } else if (
      durationType === "days" &&
      (totalHours > 999 || durationValue < 1 || durationValue > 40)
    ) {
      setError("Please enter a valid duration with days between 1 and 40.");
      return;
    }

    setError("");
    dispatch(
      updateClientPublishBankContractDuration({
        bankContractPublishHours: totalHours,
        loading: isLoading,
        setLoading: setIsLoading,
      }),
    );
  };

  return (
    <ModalPopUp
      show={bankPublishContractDurationModal}
      panelClass="max-w-[540px] max-sm:max-w-[400px]"
    >
      <div className="BankedPublishTimedurationDropDown_wrapper dropdown grid gap-4">
        <div className="flex justify-between gap-2">
          <h4 className="text-[20px] font-semibold leading-[normal] text-black">
            Bank Contracts Publish
          </h4>
          <button
            onClick={() => {
              dispatch(toggleBankPublishContractDurationModal(false));
              dispatch(
                updateBankContractPublishHours(oldBankContractPublishHours),
              );
              resetToOldValues();
            }}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        {setbankContractPublishLoading ? (
          <BankedPublishSkeleton />
        ) : (
          <>
            <div className="p-0">
              <div className="grid gap-4">
                <div>
                  <label className="text-[14px] font-medium leading-[normal] text-txtColor">
                    Specify the duration after which the contract will be made
                    available to all AppLocum candidates if no Bank candidates
                    are booked during that time.
                  </label>
                </div>
                <div className="flex items-center gap-3">
                  {durationType === "days" ? (
                    <>
                      <Select
                        value={durationValue}
                        onChange={handleDurationChange}
                        style={{ width: "30%" }}
                        placeholder="Select days"
                        className="h-[45px] w-full rounded-lg border border-blue !text-base font-medium leading-[normal] text-black"
                        suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                        showSearch
                      >
                        {Array.from({ length: 40 }, (_, i) => (
                          <Select.Option key={i + 1} value={i + 1}>
                            {i + 1}
                          </Select.Option>
                        ))}
                      </Select>
                    </>
                  ) : (
                    <>
                      <Input
                        type="number"
                        value={durationValue}
                        onChange={(e) => handleDurationChange(e.target.value)}
                        suffix={<TimePickerClock cls={"text-primary"} />}
                        placeholder="Enter hours"
                        style={{ width: "30%" }}
                        className={`h-[45px] w-full rounded-lg border !text-base font-medium leading-[normal] text-black ${error ? "border-red-500" : "border-blue"}`}
                        onKeyPress={(e) => {
                          if (e.key === "." || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </>
                  )}
                  <Select
                    value={durationType}
                    onChange={(value) => {
                      setDurationType(value);
                      setDurationValue(""); // Clear value when switching between days and hours
                      setError("");
                    }}
                    style={{ width: "30%" }}
                    className="h-[45px] w-full rounded-lg border border-blue !text-base font-medium leading-[normal] text-black"
                    suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                  >
                    <Select.Option value="days">Days</Select.Option>
                    <Select.Option value="hours">Hours</Select.Option>
                  </Select>
                </div>
                {error && <div className="mt-2 text-red">{error}</div>}
              </div>
              <div className="mt-5 flex justify-end gap-4">
                <button
                  className="transition-linear relative h-[45px] w-[90px] rounded-lg border border-primary bg-primary text-[14px] font-medium text-white hover:bg-none hover:text-primary"
                  onClick={handleSave}
                >
                  {isLoading ? <ButtonLoader /> : "Save"}
                </button>
                <button
                  className="transition-linear relative h-[45px] w-[80px] rounded-lg border border-primary bg-white text-[14px] font-medium text-blue hover:bg-blue hover:text-white"
                  onClick={() => {
                    dispatch(toggleBankPublishContractDurationModal(false));
                    dispatch(
                      updateBankContractPublishHours(
                        oldBankContractPublishHours,
                      ),
                    );
                    resetToOldValues();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </ModalPopUp>
  );
};

export default BankedPushlishContractDurationModal;
